import { render, staticRenderFns } from "./GameScore.vue?vue&type=template&id=3aa28824&"
import script from "./GameScore.vue?vue&type=script&lang=js&"
export * from "./GameScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GameScore.vue"
export default component.exports